export const QUOTES_PAGE_STORAGE_KEY = 'dashboard.quotes.page';
export const QUOTES_SEARCH_STORAGE_KEY = 'dashboard.quotes.search';
export const QUOTES_STATUS_STORAGE_KEY = 'dashboard.quotes.status';

export function readStoredQuotePage() {
  const stored = parseInt(sessionStorage.getItem(QUOTES_PAGE_STORAGE_KEY), 10);
  return Number.isFinite(stored) && stored >= 1 ? stored : 1;
}

export function storeQuotePage(page) {
  sessionStorage.setItem(QUOTES_PAGE_STORAGE_KEY, String(Math.max(1, page)));
}

export function clearStoredQuotePage() {
  sessionStorage.removeItem(QUOTES_PAGE_STORAGE_KEY);
}

export function readStoredQuoteSearch() {
  return sessionStorage.getItem(QUOTES_SEARCH_STORAGE_KEY) || '';
}

export function storeQuoteSearch(term) {
  const next = String(term || '');
  if (next) sessionStorage.setItem(QUOTES_SEARCH_STORAGE_KEY, next);
  else sessionStorage.removeItem(QUOTES_SEARCH_STORAGE_KEY);
}

export function readStoredQuoteStatus() {
  return sessionStorage.getItem(QUOTES_STATUS_STORAGE_KEY) || 'all';
}

export function storeQuoteStatus(status) {
  const next = String(status || 'all');
  if (next && next !== 'all') sessionStorage.setItem(QUOTES_STATUS_STORAGE_KEY, next);
  else sessionStorage.removeItem(QUOTES_STATUS_STORAGE_KEY);
}

export function getPageFromReturnPath(returnPath) {
  if (!returnPath) return null;
  const queryIndex = returnPath.indexOf('?');
  if (queryIndex === -1) return null;
  const page = parseInt(new URLSearchParams(returnPath.slice(queryIndex + 1)).get('page'), 10);
  return Number.isFinite(page) && page >= 1 ? page : null;
}

/** Resolve list page: URL param → navigation state → sessionStorage. */
export function resolveQuoteListPage(location) {
  const urlParams = new URLSearchParams(location.search || '');
  const pageParam = parseInt(urlParams.get('page'), 10);
  if (Number.isFinite(pageParam) && pageParam >= 1) return pageParam;

  const statePage = parseInt(location.state?.quotesPage, 10);
  if (Number.isFinite(statePage) && statePage >= 1) return statePage;

  return readStoredQuotePage();
}

export function resolveQuoteListSearch(location) {
  const urlParams = new URLSearchParams(location.search || '');
  if (urlParams.has('q')) return urlParams.get('q') || '';
  if (typeof location.state?.quoteSearch === 'string') return location.state.quoteSearch;
  return readStoredQuoteSearch();
}

export function resolveQuoteListStatus(location) {
  const urlParams = new URLSearchParams(location.search || '');
  if (urlParams.has('status')) return urlParams.get('status') || 'all';
  if (typeof location.state?.quoteStatus === 'string') return location.state.quoteStatus;
  return readStoredQuoteStatus();
}

export function buildQuotesDashboardReturnPath(locationSearch, page, extras = {}) {
  const params = new URLSearchParams(locationSearch || '');
  params.set('tab', 'quotes');
  const resolvedPage = Math.max(1, Number(page) || 1);
  if (resolvedPage > 1) {
    params.set('page', String(resolvedPage));
  } else {
    params.delete('page');
  }

  const search =
    extras.q !== undefined ? String(extras.q || '') : params.get('q') || '';
  if (search.trim()) params.set('q', search.trim());
  else params.delete('q');

  const status =
    extras.status !== undefined ? String(extras.status || 'all') : params.get('status') || 'all';
  if (status && status !== 'all') params.set('status', status);
  else params.delete('status');

  return `/dashboard?${params.toString()}`;
}

/** State to pass when navigating back to the quotes list. */
export function buildQuotesListBackState(returnPath, quotesPage) {
  const page =
    Number.isFinite(quotesPage) && quotesPage >= 1
      ? quotesPage
      : getPageFromReturnPath(returnPath);
  const queryIndex = returnPath ? returnPath.indexOf('?') : -1;
  const params =
    queryIndex >= 0 ? new URLSearchParams(returnPath.slice(queryIndex + 1)) : new URLSearchParams();
  const quoteSearch = params.get('q');
  const quoteStatus = params.get('status');
  return {
    preserveQuoteSession: true,
    ...(page ? { quotesPage: page } : {}),
    ...(quoteSearch ? { quoteSearch } : {}),
    ...(quoteStatus ? { quoteStatus } : {}),
  };
}
